
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M20.5 8C18.57 8 17 9.57 17 11.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5S22.43 8 20.5 8zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0 4c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zM15 9a1 1 0 01-1 1H1a1 1 0 110-2h13a1 1 0 011 1zM0 13a1 1 0 011-1h10a1 1 0 110 2H1a1 1 0 01-1-1zm15 5a1 1 0 01-1 1H1a1 1 0 110-2h13a1 1 0 011 1zm-3 4a1 1 0 01-1 1H1a1 1 0 110-2h10a1 1 0 011 1zM3 6h18c1.654 0 3-1.346 3-3s-1.346-3-3-3H3C1.346 0 0 1.346 0 3s1.346 3 3 3zm0-4h18a1.001 1.001 0 010 2H3a1.001 1.001 0 010-2z"}})])
          )
        }
      }
    